module.exports = __webpack_public_path__ + "static/profile-bb12bf44053f1efbcdea151d8e84c4c6.png";